import React from 'react';

const paymentMethods = [
    { src: '/assets/images/payment_services/Amex.webp', alt: 'Amex Logo' },
    { src: '/assets/images/payment_services/Mastercard.webp', alt: 'Mastercard Logo' },
    { src: '/assets/images/payment_services/Visa.webp', alt: 'Visa Logo' },
    { src: '/assets/images/payment_services/Revolut.webp', alt: 'Revolut Logo' },
    { src: '/assets/images/payment_services/ApplePay.webp', alt: 'Apple Pay Logo' },
    { src: '/assets/images/payment_services/Link.webp', alt: 'Link Logo' },
    { src: '/assets/images/payment_services/Stripe.webp', alt: 'Stripe Logo' },
]

const PaymentMethods: React.FC = () => {
    return (
        <div className='flex w-full flex-col items-center justify-center md:flex-row'>
            <div className='grid w-full grid-cols-7 items-center justify-center gap-0 md:gap-1 max-w-[500px]'>
                {paymentMethods.map((method) => (
                    <img
                        key={method.src}
                        src={method.src}
                        alt={method.alt}
                        className='block w-full min-w-0 object-contain'
                    />
                ))}
            </div>
            {/* <h4 className='ml-2 text-xs relative -top-0.5'>Secure Payments</h4> */}
        </div>
    );
};

export default PaymentMethods; 